import { ChangeDetectionStrategy, Component } from '@angular/core';
import { KeyValuePipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent, IconComponent } from "@husbanken/designsystem-angular-core";
import { Router } from "@angular/router";

export enum Filtype {
  PDF = '.pdf',
  JPG = '.jpg',
  JPEG = '.jpeg',
  PNG = '.png',
  GIF = '.gif',
  BMP = '.bmp',
  TIFF = '.tiff',
  DOC = '.doc',
  DOCX = '.docx',
  ODF = '.odf',
  XLS = '.xls',
  XLSX = '.xlsx',
  PPT = '.ppt',
  BIM = '.bim'
}

@Component({
  selector: 'app-veiledning',
  templateUrl: './veiledning.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    KeyValuePipe,
    TranslateModule,
    ButtonComponent,
    IconComponent
  ]
})

export class VeiledningComponent {
  public filtypeEnum = Filtype;

  constructor(private router: Router) {
  }

  public findRealm(): string {
    var currentUrl = this.router.url
    if (currentUrl.includes('privat')) {
      return 'privat';
    } else if (currentUrl.includes('proff')) {
      return 'proff';
    }
    return 'privat';
  }

  public navigateBack(): void {
    this.router.navigate([this.findRealm()], {queryParamsHandling: "merge"});
  }

  public scrollToElement(event: Event, elementId: string) {
    event.preventDefault();

    const targetElement = document.getElementById(elementId);
    if (targetElement) {
      targetElement.scrollIntoView({behavior: 'smooth'});
    }
  }
}
